import { Reveal } from "./Reveal";

export const Eyebrow = ({ children, className = "" }) => (
  <p className={`eyebrow flex items-center gap-3 ${className}`}>
    <span aria-hidden="true" className="inline-block h-px w-8 bg-gold" />
    {children}
  </p>
);

export const SectionHeading = ({ eyebrow, title, intro, light = false, className = "" }) => (
  <div className={`grid gap-6 md:grid-cols-12 ${className}`}>
    <Reveal className="md:col-span-4">
      <Eyebrow>{eyebrow}</Eyebrow>
    </Reveal>
    <div className="md:col-span-8">
      <Reveal delay={0.1}>
        <h2 className={`font-serif text-3xl font-light tracking-tight sm:text-4xl lg:text-5xl ${light ? "text-navy-900" : "text-paper"}`}>
          {title}
        </h2>
      </Reveal>
      {intro && (
        <Reveal delay={0.2}>
          <p className={`mt-6 max-w-2xl text-base leading-relaxed ${light ? "text-navy-700/80" : "text-ink"}`}>{intro}</p>
        </Reveal>
      )}
    </div>
  </div>
);
